import React from 'react';

const ChartSkeleton = () => {
  return (
    <div className="flex flex-col justify-start px-6 text-center align-top rounded-lg">
      <div className="h-80 bg-gray-800 rounded-lg animate-pulse flex flex-col p-4">
        <div className="h-6 bg-gray-700 rounded w-48 mx-auto mb-4"></div>
        
        <div className="flex-1 bg-gray-900 rounded-lg p-4">
          <div className="h-full bg-gray-700 rounded animate-pulse"></div>
        </div>
        
        <div className="flex justify-center gap-4 mt-4">
          <div className="h-4 bg-gray-700 rounded w-20 animate-pulse"></div>
          <div className="h-4 bg-gray-700 rounded w-20 animate-pulse"></div>
          <div className="h-4 bg-gray-700 rounded w-20 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default ChartSkeleton;

